module.exports = __webpack_public_path__ + "img/ciocan-ciprian-XGny9I-k9RM-unsplash.49cac364.jpg";